import React, { useRef, useCallback } from "react";
import "./HeroThumbsSlider.css";

const STEP = 220;

/**
 * Horizontal thumbs strip with prev/next arrows. Local UI only; RTL-aware scroll.
 */
export default function HeroThumbsSlider({
  children,
  trackClassName = "",
  wrapperClassName = "",
  ariaTrackLabel = "בחירת תמונה",
}) {
  const sliderRef = useRef(null);

  const scroll = useCallback((delta) => {
    const el = sliderRef.current;
    if (!el) return;
    const rtl = getComputedStyle(el).direction === "rtl";
    const dx = rtl ? -delta : delta;
    el.scrollBy({ left: dx, behavior: "smooth" });
  }, []);

  return (
    <div className={`hero-thumbs-slider ${wrapperClassName}`.trim()} dir="rtl">
      <button
        type="button"
        className="hero-thumbs-slider__arrow hero-thumbs-slider__arrow--left"
        onClick={() => scroll(-STEP)}
        aria-label="גלול ממוזערות אחורה"
      >
        ‹
      </button>
      <div
        ref={sliderRef}
        className={`hero-thumbs-slider__track ${trackClassName}`.trim()}
        role="list"
        aria-label={ariaTrackLabel}
      >
        {children}
      </div>
      <button
        type="button"
        className="hero-thumbs-slider__arrow hero-thumbs-slider__arrow--right"
        onClick={() => scroll(STEP)}
        aria-label="גלול ממוזערות קדימה"
      >
        ›
      </button>
    </div>
  );
}
